import InitialsAvatar, { InitialsAvatarProps } from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import './styles.scss';

interface Props extends InitialsAvatarProps {
  size?: 'sm' | 'lg';
}

export default function Avatar({ size = 'sm', ...props }: Props) {
  return (
    <InitialsAvatar
      {...props}
      className={`initials-avatar ${size === 'lg' ? 'fs-2' : 'fs-7'} ${props.className}`}
    />
  );
}
